<template>
  <div class="home-container">
    <list v-model="isLoading"
          :finished="dataLoadingFinished"
          @load="initItemFeed"
    >
      <MomentList :data="dataList"></MomentList>
    </list>
    <div class="pagination" v-if="totalCount > 0 && dataLoadingFinished && currentPage > 0">
      <pagination v-model="currentPage" :total-items="totalCount" :items-per-page="countPerPage"
                  @change="onChange"></pagination>
    </div>
    <div v-if="totalCount === 0 && dataLoadingFinished" class="moment-info">用户暂无动态</div>
  </div>
</template>

<script>
  import {Pagination, Toast, List} from "vant"
  import MomentList from "@/components/ugc_item/MomentList.vue"

  export default {
    name: "MomentItemFeedV2",
    components: {
      MomentList, Pagination, Toast, List,
    },
    props: {
      listType: {},
      refId: {},
      config: {},
    },
    data() {
      return {
        currentPage: 0,
        totalCount: 0,
        countPerPage: 0,
        offset: 0,

        isLoading: false,
        dataLoadingFinished: false,

        dataList: [],
      };
    },
    mounted() {
      this.initParams()
    },
    methods: {
      initParams() {
        let curPage = this.$route.query.page
        if (curPage) {
          this.currentPage = parseInt(curPage)
        } else {
          this.currentPage = 0
        }

        this.offset = 0
        this.dataList = []
        this.dataLoadingFinished = false
      },

      async initItemFeed() {
        this.isLoading = true

        let params = {
          page: this.currentPage,
          offset: this.offset,
          list_type: this.listType,
        }

        if (this.refId) {
          params.ref_id = this.refId
        }

        await this.$store.dispatch("GetFeedItemList", params).then((result) => {
          if (result.code === 0) {
            this.dataList.push(...result.data);
            let extra = result.extra
            this.totalCount = extra.total_count
            this.countPerPage = extra.count_per_page
            this.offset = extra.max_cursor  // 下一次请求的 offset
            this.dataLoadingFinished = !extra.has_more
          } else if (result.code === 20010) {
            this.dataList = []
            this.totalCount = 0
            this.dataLoadingFinished = true
          } else {
            Toast("请求错误")
            this.dataLoadingFinished = true
          }
        }, () => {
          Toast("网络异常")
          this.dataLoadingFinished = true
        });
        this.isLoading = false
      },

      onChange() {
        let params = {
          page: this.currentPage,
          list_type: this.listType,
        }
        this.$router.push({query: params})
        this.initParams()
        this.initItemFeed()
      },
    },
    computed: {},
    watch: {
      listType() {
        this.currentPage = 0
        this.onChange()
      },

      refId() {
        this.currentPage = 0
        this.onChange()
      },
    }
  };
</script>

<style lang="scss" scoped>
  .home-container {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }

  .pagination {
    margin: 10px 0;
    background-color: white;
  }
  .moment-info {
    text-align: center;
    padding: 12px 0;
    color: grey;
  }
</style>
